<p>Hover over the blue dots to know more about the items</p>
<div class="row">
    <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100 guide-form-field" matTooltipClass="guide-tip" matTooltip="Input Model Name">
            <app-pulsing-tooltip></app-pulsing-tooltip>
            <mat-label>Custom model name</mat-label>
            <input matInput placeholder="Custom model name" type="text" readonly>
        </mat-form-field>
        <div class="row">
            <div class="col-md-6">
                <mat-form-field appearance="outline" class="w-100 guide-form-field" matTooltipClass="guide-tip" matTooltip="The Portfolio Currency is the currency in which the portfolio is valued, and the performance are computed. It will typically be the currency of your own country, although you may choose to use one of the major international currencies for your portfolio currency.">
                    <app-pulsing-tooltip></app-pulsing-tooltip>
                    <mat-label>Portfolio currency</mat-label>
                    <input matInput placeholder="Currency" type="text" readonly>
                </mat-form-field>

            </div>
            <div class="col-md-6">
                <mat-form-field appearance="outline" class="w-100 guide-form-field" matTooltipClass="guide-tip" matTooltip="Input Rebalancing Frequency: Rebalancing involves periodically buying or selling assets in a portfolio to maintain an original or desired level of asset allocation or risk.">
                    <app-pulsing-tooltip></app-pulsing-tooltip>
                    <mat-label>Rebalancing</mat-label>
                    <input matInput placeholder="Rebalancing" type="text" readonly>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100 guide-form-field" matTooltipClass="guide-tip" matTooltip="Input Model Description">
            <app-pulsing-tooltip></app-pulsing-tooltip>
            <mat-label>Custom model description</mat-label>
            <textarea matInput placeholder="Custom model description" class="double-row-height" readonly></textarea>
        </mat-form-field>
    </div>
</div>
<div class="row">
    <div class="col-md-3">
        <mat-form-field appearance="outline" class="w-100 guide-form-field" matTooltipClass="guide-tip" matTooltip="Select the region(s) that you want to include.">
            <app-pulsing-tooltip></app-pulsing-tooltip>
            <mat-label>Region</mat-label>
            <input matInput placeholder="Region" type="text" readonly>
        </mat-form-field>
    </div>
    <div class="col-md-3">
        <mat-form-field appearance="outline" class="w-100 guide-form-field" matTooltipClass="guide-tip" matTooltip="Deselect market(s) that you want to exclude.">
            <app-pulsing-tooltip></app-pulsing-tooltip>
            <mat-label>Markets</mat-label>
            <input matInput placeholder="Markets" type="text" readonly>
        </mat-form-field>
    </div>
    <div class="col-md-3">
        <mat-form-field appearance="outline" class="w-100 guide-form-field" matTooltipClass="guide-tip" matTooltip="Deselect Sector(s) that you want to exclude." (click)="$event.preventDefault()">
            <app-pulsing-tooltip></app-pulsing-tooltip>
            <mat-label>Sectors</mat-label>
            <input matInput placeholder="Sectors" type="text" readonly>
        </mat-form-field>
    </div>
    <div class="col-md-3">
        <div class="guide-form-field" matTooltipClass="guide-tip" matTooltip="Input the Number of companies in Portfolio: Min 20, Max 100.">
            <app-pulsing-tooltip></app-pulsing-tooltip>
            <small class="text-muted"># companies in portfolio: {{numComp}}</small>
        </div>
        <div class="guide-form-field" matTooltipClass="guide-tip" matTooltip="Your portfolio is dependent on the number of companies in the universe. It is recommended to have a universe that is 10 times greater than the selected number of companies.">
            <app-pulsing-tooltip></app-pulsing-tooltip>
            <mat-slider color="primary" class="w-100" min="20" max="100" step="1" [(ngModel)]="numComp"></mat-slider>
            <mat-hint># of companies in universe: 350</mat-hint>
        </div>
    </div>
</div>
